import { render, staticRenderFns } from "./player-details.vue?vue&type=template&id=22b537d8"
import script from "./player-details.vue?vue&type=script&lang=js"
export * from "./player-details.vue?vue&type=script&lang=js"
import style0 from "./player-details.vue?vue&type=style&index=0&id=22b537d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports